import { type FormEvent, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/providers/auth-provider";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  // Navigate back to the route the user originally tried to access, or /grids
  const from = (location.state as { from?: string } | null)?.from ?? "/grids";

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex h-full items-center justify-center bg-bg">
      <form
        onSubmit={handleSubmit}
        className="flex w-72 flex-col gap-4 rounded-lg border border-border bg-surface p-8"
      >
        <h1 className="flex justify-center">
          <img src="/kuant-logo.svg" alt="kuant" className="h-10 w-auto" />
          <span className="sr-only">kuant</span>
        </h1>
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="rounded border border-border bg-bg px-3 py-2 text-text placeholder:text-muted focus:outline-none focus:ring-1 focus:ring-accent"
          required
          autoFocus
        />
        {error && <p className="text-sm text-danger">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          className="rounded bg-accent px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
        >
          {loading ? "Logging in…" : "Login"}
        </button>
      </form>
    </div>
  );
}
